import { triggerAuthFailureNavigation } from '@app/store/appState';

class NavigationService {
  constructor() {
    this.dispatch = null;
  }

  setDispatch(dispatch) {
    this.dispatch = dispatch;
  }

  triggerAuthFailure() {
    if (this.dispatch) {
      this.dispatch(triggerAuthFailureNavigation());
      return;
    }

    // eslint-disable-next-line no-console
    console.error(
      'NavigationService: dispatch not set, falling back to window.location',
    );
    window.location.href = '/auth-failure';
  }
}

// Export singleton instance
export default new NavigationService();
